




















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Action, Getter, Mutation } from 'vuex-class'
import InfiniteLoading from 'vue-infinite-loading'

import Dayjs from 'dayjs'

import _capitalize from 'lodash/capitalize'
import _debounce from 'lodash/debounce'
import _findIndex from 'lodash/findIndex'
import _get from 'lodash/get'
import _toLower from 'lodash/toLower'

import { Book, Offer, OfferItem, Seller, SEARCH_TYPE, OFFER_REVISION_STATE_CODE } from '@/types'
import { OfferCartsState } from '@/store/offer-carts/types'
import { stringToCurrency, stringToNumber } from '@/utils/numeric.util'
import GuidePricesTable from '@/components/GuidePricesTable.vue'
import CurrencyInput from '@/components/CurrencyInput.vue'
import QtyInput from '@/components/QtyInput.vue'
import SearchInput from '@/components/SearchInput.vue'

const namespace: string = 'offerCarts'

@Component({
  components: {
    InfiniteLoading,
    GuidePricesTable,
    SearchInput,
    CurrencyInput,
    QtyInput,
  },
  methods: {
    _capitalize,
    _get,
  },
})
export default class OfferCartPage extends Vue {
  @State('offerCarts') private offerCartsState: OfferCartsState | undefined
  @Getter('getActiveOffer', { namespace }) private activeOffer: Offer | undefined
  @Getter('getActiveSeller', { namespace: 'sellers' }) private activeSeller: Seller | undefined

  @Mutation('setBestBook', { namespace: 'books' }) private setBestBook: any

  @Getter('getUserInfo', { namespace: 'auth' }) private userInfo: any
  @Action('deleteOffer', { namespace }) private deleteOffer: any
  @Action('getOfferItems', { namespace }) private getOfferItems: any
  @Action('putOfferItem', { namespace }) private putOfferItem: any
  @Action('deleteOfferItem', { namespace }) private deleteOfferItem: any
  @Action('postOfferComplete', { namespace }) private postOfferComplete: any
  @Action('postOfferRevise', { namespace }) private postOfferRevise: any

  private helperKeywordText: string = 'Type or scan an ISBN'
  private searchType = SEARCH_TYPE.OFFER_ITEM
  private searchKeyword: string = ''
  private debouncedChangeOfferItemQuantity = _debounce(this.changeOfferItemQuantity, 600)
  private debouncedChangeOfferItemPrice = _debounce(this.changeOfferItemPrice, 1000)

  private infiniteId: number = new Date().getTime()
  private itemsPerPage: number = 10
  private offset: number = 0
  private offerItems: OfferItem[] = []
  private totalNumberOfferItems: number = 0
  private totalOfferPrice: number = 0
  private money = {
    decimal: '.',
    thousands: ',',
    prefix: '$ ',
    suffix: '',
    precision: 2,
    masked: false,
  }
  private changingOfferItem: OfferItem | null = null
  private updatingOfferItems: OfferItem[] = []
  private prevTotalOfferPrice = 0

  private mounted(): void {
    this.totalOfferPrice =
      this.activeOffer && this.activeOffer.offerTotal ? this.activeOffer.offerTotal : 0
    this.$socket.client.on('InventoryList-Processing', data => {
      if (this.activeOffer) {
        this.offset = 0
        this.infiniteId += 1
      }
    })
  }

  private destroyed(): void {}

  get offerCreatedDay() {
    const temp = _get(this.activeOffer, 'createdAt') || ''
    return temp ? Dayjs(temp).format('ddd') : ''
  }

  get offerCreatedDate() {
    const temp = _get(this.activeOffer, 'createdAt') || ''
    return temp ? Dayjs(temp).format('MM/DD') : ''
  }

  get offerState() {
    return _capitalize(
      _get(this.activeOffer, [
        'offerRevisions',
        0,
        'offerRevisionStates',
        0,
        'revisionStateCode',
      ]) || ''
    )
  }

  get formattedTotalOfferPrice() {
    return this.totalOfferPrice ? `$${stringToCurrency(this.totalOfferPrice)}` : '$0.00'
  }

  get revisingOffer() {
    return _get(this.offerCartsState, ['requestPostOfferRevise']) || false
  }

  get completingOffer() {
    return _get(this.offerCartsState, ['requestPostOfferComplete']) || false
  }

  private getValidation(offerItem: OfferItem) {
    return { required: true }
  }

  private getValidationClass(value) {
    return {
      'md-invalid': !value,
    }
  }

  private getQuantity(offerItem: OfferItem) {
    return _get(offerItem, ['quantity']) || 0
  }

  private getOfferItemPrice(offerItem: OfferItem) {
    let offerPrice = _get(offerItem, ['offerPrice']) || 0

    if (isNaN(offerPrice)) {
      offerPrice = stringToNumber(offerPrice, 'float')
    }

    const price = stringToCurrency(offerPrice * this.getQuantity(offerItem))
    return price ? `$${price}` : '$0.00'
  }

  private getBookOfferPrice(offerItem: OfferItem) {
    const price = stringToCurrency(_get(offerItem, ['offerPrice']))
    return price ? `$${price}` : '$0.00'
  }

  private deletingOfferItem(offerItemId: string) {
    if (
      (_get(this.offerCartsState, ['deletingOfferItemIds']) || []).indexOf(offerItemId) >= 0 ||
      (_get(this.offerCartsState, ['updatingOfferItemIds']) || []).indexOf(offerItemId) >= 0
    )
      return true
    return _get(this.offerCartsState, ['requestDeleteOffer']) || false
  }

  private onSubmitKeyword(keyword: string): void {
    this.offset = 0
    this.infiniteId += 1
  }

  private infiniteHandler($state) {
    if (!this.activeOffer) {
      $state.loaded()
      $state.complete()
      return
    }

    const infiniteId = this.infiniteId

    this.helperKeywordText = 'Searching...'

    this.getOfferItems({
      limit: this.itemsPerPage,
      offset: this.offset,
      order: [['createdAt', 'desc']],
      keyword: this.searchKeyword,
      offerId: this.activeOffer!.id,
    })
      .then(res => {
        if (infiniteId !== this.infiniteId) {
          return
        }

        const temp = (_get(res, 'rows') || []).map(r => ({
          ...r,
          offerPrice: r.offerPrice || 0,
        })) // .toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")

        this.totalNumberOfferItems = _get(res, 'count') || 0
        this.offerItems = !this.offset ? temp : [...this.offerItems, ...temp]

        $state.loaded()
        if (this.offerItems.length >= this.totalNumberOfferItems) {
          $state.complete()
        }

        this.offset += temp.length || 0
        if (!temp.length && this.offset === 0) {
          Vue.$toast.error('No matches found.')
        }
      })
      .catch(err => {
        $state.loaded()
        $state.complete()
      })
      .finally(() => {
        this.helperKeywordText = 'Type or scan an ISBN'
      })
  }

  private onChangeOfferItemQuantity(index: number, quantity: number) {
    if (!this.changingOfferItem || this.changingOfferItem.id !== this.offerItems[index].id) {
      this.changingOfferItem = {
        ...this.offerItems[index],
      }
      this.prevTotalOfferPrice = _get(this.activeOffer, 'offerTotal') || 0
    }
    this.totalOfferPrice =
      this.prevTotalOfferPrice -
      this.offerItems[index].offerPrice * (this.changingOfferItem.quantity - quantity)
    this.offerItems[index].quantity = quantity
    this.debouncedChangeOfferItemQuantity(index, quantity)
  }

  private onChangeOfferItemPrice(index: number, event: { value: number; state: string }) {
    // state: 'changing' || 'changed'

    if (!this.changingOfferItem || this.changingOfferItem.id !== this.offerItems[index].id) {
      this.changingOfferItem = {
        ...this.offerItems[index],
      }
      this.prevTotalOfferPrice = _get(this.activeOffer, 'offerTotal') || 0
    }

    this.totalOfferPrice =
      this.prevTotalOfferPrice -
      (this.changingOfferItem.offerPrice - event.value) * this.offerItems[index].quantity

    this.offerItems[index].offerPrice = event.value
    if (event.state === 'changed') {
      this.changeOfferItemPrice(index, this.offerItems[index].offerPrice, event.value)
    }
  }

  private changeOfferItemPrice(index: number, prevValue: number, value: number) {
    const offerItemId = this.offerItems[index].id
    const data = {
      offerPrice: value,
    }

    this.updatingOfferItems.push(this.changingOfferItem as OfferItem)
    this.changingOfferItem = null
    const updatingOfferItemIndex = this.updatingOfferItems.length - 1

    this.putOfferItem({
      id: offerItemId,
      data,
    })
      .then(res => {
        if (res) {
          const temp = {
            ...res,
            offerPrice: this.offerItems[index].offerPrice,
          } // .toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")

          this.offerItems[index] = temp
          const tempOfferItems = this.offerItems.filter(
            oi =>
              oi.id !== offerItemId &&
              oi.bookId === this.offerItems[index].bookId &&
              oi.conditionId === this.offerItems[index].conditionId &&
              oi.offerPrice === value
          )
          this.offerItems = this.offerItems.filter(
            oi => _findIndex(tempOfferItems, to => to.id === oi.id) < 0
          )
          this.offset = Math.max(this.offset - tempOfferItems.length, 0)
        }
      })
      .catch(err => {
        this.offerItems[index].offerPrice = this.updatingOfferItems[
          updatingOfferItemIndex
        ].offerPrice
        this.totalOfferPrice =
          this.totalOfferPrice -
          (value - this.offerItems[index].offerPrice) * this.offerItems[index].quantity
      })
      .finally(() => {
        this.updatingOfferItems.splice(updatingOfferItemIndex, 1)
      })
  }

  private changeOfferItemQuantity(index: number, quantity: number) {
    this.updatingOfferItems.push(this.changingOfferItem as OfferItem)
    this.changingOfferItem = null

    const updatingOfferItemIndex = this.updatingOfferItems.length - 1
    const data = {
      quantity,
    }
    this.putOfferItem({
      id: this.offerItems[index].id,
      data,
    })
      .then(res => {
        this.offerItems[index] = res
      })
      .catch(err => {
        this.offerItems[index].offerPrice = this.updatingOfferItems[
          updatingOfferItemIndex
        ].offerPrice
        this.totalOfferPrice =
          this.prevTotalOfferPrice -
          this.updatingOfferItems[updatingOfferItemIndex].offerPrice *
            (quantity - this.updatingOfferItems[updatingOfferItemIndex].quantity)
      })
      .finally(() => {
        this.updatingOfferItems.splice(updatingOfferItemIndex, 1)
      })
  }

  private onClickNewOffer() {
    const userRole = _toLower(_get(this.userInfo, ['role', 'name']))
    if (userRole === 'seller') {
      this.$router.replace({ name: 'BookSearchByISBN' })
    } else {
      this.$router.replace({ name: 'Sellers' })
    }
  }

  private onClickOfferItem(offerItem: OfferItem) {
    this.setBestBook(_get(offerItem, ['book']) || null)
    this.$router.push({ name: 'BookSearchByISBN' })
  }

  private onClickDeleteButton(offerItem: OfferItem) {
    if (this.offerItems.length < 2) {
      this.deleteOffer(this.activeOffer!.id)
        .then(() => {
          this.offerItems = []
          this.totalNumberOfferItems = 0
          Vue.$toast.success('The offer cart has been deleted.')
        })
        .catch(err => {})
        .finally(() => {})
    } else {
      this.deleteOfferItem(offerItem.id)
        .then(() => {
          this.offerItems = this.offerItems.filter(i => i.id !== offerItem.id)
          this.totalNumberOfferItems -= 1
        })
        .catch(err => {})
        .finally(() => {})
    }
  }

  private onClickCompleteOffer() {
    if (!this.activeOffer) return

    this.postOfferComplete(this.activeOffer!.id)
      .then(() => {
        Vue.$toast.success('The offer has been completed.')
      })
      .catch(err => {})
      .finally(() => {})
  }

  private onClickReviseOffer() {
    if (!this.activeOffer) return

    this.postOfferRevise(this.activeOffer!.id)
      .then(() => {
        Vue.$toast.success(`You're now editing the offer.`)
      })
      .catch(err => {})
      .finally(() => {})
  }
}
